import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { GoogleMap } from '@angular/google-maps';
import { PropertySearchBoxFacade } from '../../../facades/property-search-box.facade';
import { DropdownOptionVM } from '../../../models/home.vm';
import { SearchCriteria } from '../../../models/search-criteria.model';

/**
 * Buscador hero (dialog). UI + mapa; la orquestación de catálogos y la cascada
 * depto→ciudad→barrio viven en {@link PropertySearchBoxFacade}. Al buscar
 * publica el criterio (el marketplace del Slice 1 lo consume) y navega.
 */
@Component({
    selector: 'app-rc-search-property',
    templateUrl: './rc-search-property.component.html',
    styleUrls: ['./rc-search-property.component.scss'],
    providers: [PropertySearchBoxFacade],
})
export class RcSearchPropertyComponent implements OnInit {
    @Input() showDialogSearch = false;
    @Output() closeDialogSearch = new EventEmitter<boolean>();

    errorMessage: string | null = null;
    dialogVisible = false;

    // Selección del usuario
    selectedSegmentId: number | null = null;
    selectedOfferId: number | null = null;
    selectedDepartment: string | null = null;
    hoveredDepartment: string | null = null;
    selectedCity: DropdownOptionVM | null = null;
    selectedNeighborhood: DropdownOptionVM | null = null;
    priceRange = [0, 100000];

    private readonly decimalPipe = new DecimalPipe('en-US');

    // Mapa
    markerPositions: google.maps.LatLngLiteral[] = [];
    markerOptions: google.maps.MarkerOptions = {
        icon: {
            url: 'assets/layout/images/icons/icon-map-home.png',
            scaledSize: new google.maps.Size(30, 30),
            anchor: new google.maps.Point(21, 21),
        },
    };
    circleOptions: google.maps.CircleOptions = {
        fillColor: '#6bb5c6',
        fillOpacity: 0.12,
        strokeColor: '#6bb5c6',
        strokeOpacity: 0.7,
        strokeWeight: 3,
    };
    center: google.maps.LatLngLiteral = { lat: -16.5, lng: -68.15 };
    zoom = 15;
    @ViewChild('mapRef') mapRef!: GoogleMap;

    constructor(
        readonly facade: PropertySearchBoxFacade,
        private readonly router: Router,
    ) {}

    ngOnInit(): void {
        this.facade.loadCatalogs();
    }

    dialogOpened(): void {
        this.dialogVisible = true;
    }

    closeDialog(): void {
        this.showDialogSearch = false;
        this.dialogVisible = false;
        this.closeDialogSearch.emit(false);
    }

    getFormattedValue(value: number): string {
        return this.decimalPipe.transform(value, '1.2-2') || '';
    }

    onSegmentSelect(segmentId: number): void {
        this.selectedSegmentId = this.selectedSegmentId === segmentId ? null : segmentId;
    }

    selectOffer(adId: number, event: Event): void {
        event.stopPropagation();
        this.selectedOfferId = this.selectedOfferId === adId ? null : adId;
    }

    onDepartmentSelect(departmentCode: string): void {
        this.selectedDepartment = departmentCode;
        this.selectedCity = null;
        this.selectedNeighborhood = null;
        this.facade.loadCities(departmentCode);
    }

    onCityChange(event: any): void {
        this.selectedCity = event.value;
        this.selectedNeighborhood = null;
        if (this.selectedCity) {
            this.facade.loadZones(this.selectedCity.value);
        }
    }

    onNeighborhoodChange(event: any): void {
        this.selectedNeighborhood = event.value;
        if (this.selectedNeighborhood && this.selectedCity && this.selectedDepartment) {
            const address = `${this.selectedNeighborhood.label}, ${this.selectedCity.label}, ${this.selectedDepartment}, Bolivia`;
            this.updateMapCenter(address);
        }
    }

    updateMapCenter(address: string): void {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK && results && results[0]) {
                const loc = results[0].geometry.location;
                this.center = { lat: loc.lat(), lng: loc.lng() };
                this.zoom = 15;
                this.markerPositions = [this.center];
            }
        });
    }

    onCenterChanged(): void {
        const center = this.mapRef?.getCenter?.();
        if (center) {
            this.center = center.toJSON();
        }
    }

    addMarker(event: google.maps.MapMouseEvent): void {
        if (event.latLng != null) {
            this.markerPositions.push(event.latLng.toJSON());
        }
    }

    submitSearch(): void {
        const criteria: SearchCriteria = {};
        let hasFilter = false;

        if (this.selectedSegmentId) { criteria.segmentId = this.selectedSegmentId; hasFilter = true; }
        if (this.selectedOfferId) { criteria.adId = this.selectedOfferId; hasFilter = true; }
        if (this.selectedCity) { criteria.cityId = this.selectedCity.value; hasFilter = true; }
        if (this.selectedNeighborhood) { criteria.zoneId = this.selectedNeighborhood.value; hasFilter = true; }

        if (this.priceRange?.length === 2) {
            criteria.amount1 = String(this.priceRange[0]);
            criteria.amount2 = String(this.priceRange[1]);
        }
        if (!hasFilter) {
            criteria.defaultPage = true;
        }

        this.facade.submit(criteria);
        this.closeDialog();
        this.router.navigate(['/list-search']);
    }
}
